import Scaler from './scaler';

import Image from './image';
import Qrcode from './qrcode';
import Chart from './chart';

import Button from './button';
import Input from './input';
import Radio from './radio';
import Checkbox from './checkbox';

import Editor from './editor';
import Textarea from './textarea';
import Table from './table';
import TableColumn from './table/column';

import Switch from './switch';
import Label from './label';
import LabelGroup from './label/group';
import Upload from './upload';
import UploadImage from './upload/image';

import Popover from './popover';
import Select from './select';
import SelectOption from './select/option';
import SelectOptions from './select/options';
import Cascader from './cascader';
import SelectRegion from './select/region';

import DatePanel from './panel/date';
import DateRangePanel from './panel/date-range';

import Picker from './picker';
import DatePicker from './picker/date';
import DateRangePicker from './picker/date-range';

import Tab from './tab';
import TabGroup from './tab/group';
import Tree from './tree';
import Pagination from './pagination';

import Modal from './modal';
import Dialog from './dialog';
import Custom from './dialog/custom';
import Message from './modal/message';

import region from './select/region/data.json';

export default {
	install(Vue, config = {}) {

		Object.entries({

			Scaler,

			Image,
			Qrcode,
			Chart,

			Button,
			Input,
			Radio,
			Checkbox,

			Editor,
			Textarea,
			Table,
			TableColumn,

			Switch,
			Label,
			LabelGroup,
			Upload,
			UploadImage,

			Popover,
			Select,
			SelectOption,
			SelectOptions,
			Cascader,
			SelectRegion,

			DatePanel,
			DateRangePanel,

			Picker,
			DatePicker,
			DateRangePicker,

			Tab,
			TabGroup,
			Tree,
			Pagination,

			Modal,
			Dialog,
			Message

		}).forEach(([k, v]) => Vue.component(`V${k}`, v));

		/**
		 * Vue属性扩展
		 */
		Object.defineProperties(Vue.prototype, {
			$disabled: {
				get() {
					return 'disabled' in this.$attrs && (this.$attrs.disabled === '' || this.$attrs.disabled != false);
				}
			},
			$region: {
				value(...args) {
					console.log();
					return args.map(o => (region.filter(r => r.c == o)[0] || {}).n);
				}
			}
		});

		/**
		 * 弹窗及接口
		 */
		Vue.prototype.$ = Object.assign(function (e, closed) {
			return {
				async	open(...args) {
					let XDialog = isFunction(e) ? (await e()).default : e,
						{ created = () => { }, methods = {} } = XDialog,
						{ close = () => { } } = methods;
					return new Vue({
						router: config.router,
						el: Element.create('template'),
						render($) {
							return $('v-modal', [
								$(Object.assign({}, XDialog, {
									created() {
										created.apply(this, args);
										this.$parent.open();
									},
									methods: Object.assign({}, methods, {
										close() {
											close.apply(this, arguments);
											this.$parent.close();
											isFunction(closed) && closed.apply(this, arguments);
										}
									})
								}))
							]);
						}
					});
				}
			}
		}, config.apis);

		/**
		 * 自定义弹窗
		 * @param {string} message 消息内容
		 * @param {number} duration 持续时长
		 * @param {string} type 消息类型
		 */
		Vue.prototype.$dialog = function (option, callback) {
			this.$(Custom).open.apply(this, arguments);
		}

	}
}